import * as Utils from '@shared/core/utils';
import { createSelector } from '@ngrx/store';
import { getWizzardSimpleItem } from '@shared/state/wizzard/selectors';
import { getAppSettingsTags } from '../../../appSettings/selectors';

export const isWizzardSimpleItemFeatured = createSelector(getWizzardSimpleItem, getAppSettingsTags, (wizzardSimpleItem, appTagSettings) => {
    const tags = wizzardSimpleItem?.Tags || [];

    return new Utils.TagSettingsUtils(tags, appTagSettings).isFeaturedMenuItem;
});
